/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createHook } from '../../core/factories/createHook.js';

import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetMarketConfigsRow } from '../openapi-types.gen.js';
import { type useGetMarketConfigsArgs, useGetMarketConfigsSpec } from '../specs/market-configs.spec.gen.js';

export type { GetMarketConfigsRow } from '../openapi-types.gen.js';
export type { useGetMarketConfigsArgs } from '../specs/market-configs.spec.gen.js';


const _useGetMarketConfigs = createHook(useGetMarketConfigsSpec);
export const useGetMarketConfigs = _useGetMarketConfigs as (args: useGetMarketConfigsArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetMarketConfigs>;


/**
 * Hover/intent prefetch companion for `useGetMarketConfigs`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetMarketConfigs();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetMarketConfigs = createPrefetchHook(useGetMarketConfigsSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetMarketConfigsArgs>;
